import { render, staticRenderFns } from "./toBindingCustomer.vue?vue&type=template&id=7b340641&scoped=true&"
import script from "./toBindingCustomer.vue?vue&type=script&lang=js&"
export * from "./toBindingCustomer.vue?vue&type=script&lang=js&"
import style0 from "./toBindingCustomer.vue?vue&type=style&index=0&id=7b340641&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b340641",
  null
  
)

export default component.exports